import {Request} from "../../request.abstract";
import {Observable} from "rxjs/Rx";
import {StatisticResponse} from "./api.models";

export class UserStatisticsEndpoint extends Request {
    collection(page?: number, perPage?: number, from?: string, to?: string): Observable<StatisticResponse> {
        return this.get('/v1/messages/user-statistics', this.createSearch({
            page: page,
            perPage: perPage,
            from: from,
            to: to
        }));
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/messages/userStatistics/api.service.ts